var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBasketDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.29102 8.52783L9.02905 3.00012",
    stroke: "#08081B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0847 8.52783L15.3467 3.00012",
    stroke: "#08081B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4904 21.1624H4.88461C4.18059 21.1496 3.57775 20.6544 3.42845 19.9663L1.17735 10.4902C1.05527 10.0305 1.14925 9.5402 1.43268 9.15819C1.71611 8.77618 2.15812 8.54409 2.63351 8.52765H21.7415C22.2169 8.54409 22.6589 8.77618 22.9423 9.15819C23.2258 9.5402 23.3197 10.0305 23.1976 10.4902L20.9466 19.9663C20.7972 20.6544 20.1944 21.1496 19.4904 21.1624Z",
    stroke: "#08081B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.44922 11.6866V18.004",
    stroke: "#08081B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1875 11.6866V18.004",
    stroke: "#08081B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9258 11.6866V18.004",
    stroke: "#08081B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasketDark);
export default __webpack_public_path__ + "static/media/basket-dark.c5f9bbbe91f1cd606962b352b6fff11e.svg";
export { ForwardRef as ReactComponent };